import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { graphqlClient } from 'bk-web-app';
import CompanyDetailsContent from './CompanyDetailsContent';

const CompanyDetails: React.FC = () => (
  <ApolloProvider client={graphqlClient}>
    <CompanyDetailsContent />
  </ApolloProvider>
);

export default CompanyDetails;
